mutation PublishSchedule(
  $startsAt: ISO8601DateTime!
  $endsAt: ISO8601DateTime!
  $lineIds: [ID!]
  $lineTypes: [String!]
) {
  publishSchedule(startsAt: $startsAt, endsAt: $endsAt, lineIds: $lineIds, lineTypes: $lineTypes) {
    publishedSchedule {
      createdIds
      updatedIds
      success
      workBlocks {
        id
        jobId
        startsAt
        line {
          name
        }
        workOrder {
          code
        }
      }
      errors {
        message
        path
      }
    }
  }
}

query PublishScheduleDryRun(
  $startsAt: ISO8601DateTime!
  $endsAt: ISO8601DateTime!
  $lineIds: [ID!]
  $lineTypes: [String!]
) {
  publishScheduleDryRun(startsAt: $startsAt, endsAt: $endsAt, lineIds: $lineIds, lineTypes: $lineTypes) {
    count
    jobsToCreateCount
    jobsToUpdateCount
    blocksOnInactiveLinesCount
  }
}
